import React from 'react';
import graphql from 'graphql';
import Link from "gatsby-link";
import Helmet from 'react-helmet';
import Content, { HTMLContent } from '../components/Content';
import Team from '../components/Team';
import ResourceList from '../components/ResourceList';
import Contact from '../components/Contact';
import CaseStudiesSection from '../components/CaseStudiesSection'

export const CaseStudiesPageTemplate = ({ title, content, caseStudies, contentComponent }) => {
  const PageContent = contentComponent || Content;

  return (
    <div>
      <Helmet
        title="San Juan Software | Case Studies"
      />
      <CaseStudiesSection caseStudies={caseStudies} />
      <Contact />
    </div>
  );
};

export default ({ data }) => {
  const { frontmatter, html } = data.markdownRemark;
  const caseStudies = data.allMarkdownRemark.edges;
  
  return (<CaseStudiesPageTemplate
    contentComponent={HTMLContent}
    title={frontmatter.title}
    content={html}
    caseStudies={caseStudies}
  />);
};

export const PageQuery = graphql`
  query caseStudiesPage($path: String!) {
    markdownRemark(frontmatter: { path: { eq: $path } }) {
        html
        frontmatter {
            path
            title
        }
    }
    allMarkdownRemark(
      sort: { order: DESC, fields: [frontmatter___date] }
      filter: { fileAbsolutePath: {regex : "/src/pages/case-studies/_/"} })
      {
      edges {
        node {
          html
          frontmatter {
            title
            date(formatString: "MMMM DD, YYYY")
            path
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/case-studies-page.js